// @flow
import { useParams } from 'react-router-dom';
import React, { useCallback, useMemo } from 'react';
import { DataFetcherContainer } from '@presentational/DataFetcherContainer';
import { shouldSkipDataFetching } from '@src/common-utils/utils';
import { useGetSPFlinkWorkloadViewQuery } from '@streaming-projects/service-definitions/streamingProjectsApi';

import { FlinkPoolWorkloadContext } from './FlinkPoolWorkloadContext';

export const FlinkPoolWorkloadContextProvider = ({ children }) => {
  const params = useParams();

  return (
    <DataFetcherContainer
      dataFetchingArgs={useMemo(
        () => [
          { ...params },
          {
            skip: shouldSkipDataFetching(params),
          },
        ],
        [params]
      )}
      dataFetchingFunction={useCallback(useGetSPFlinkWorkloadViewQuery, [])}
    >
      {(data) => {
        return (
          <FlinkPoolWorkloadContext.Provider value={data}>
            {children}
          </FlinkPoolWorkloadContext.Provider>
        );
      }}
    </DataFetcherContainer>
  );
};
